<lib-modal-layout [title]="'Loss Runs Request'" [subtitle]="data.businessName + ' | ' + data.policyNumber">
  
        <div class="flex flex-col w-full my-6 text-center">
          <b>Policy Term: {{data.policyTerm}}</b> 
        </div>
        <div class="flex flex-col w-full my-4  text-center">
            <lib-button [type]="'submit'" [text]="'Submit'"  (click)="onSubmit()"
                [icon]="'rightarrow'"></lib-button>
        </div>

</lib-modal-layout>